import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    overflow: 'scroll',
  },
  containerInside: {
    maxWidth: '1200px',
    margin: '0px auto',
    marginTop: '20px',
    padding: 10,
    lineHeight: '170%',
  },
  listText: {
    marginTop: '5px',
    listStyleType: 'none',
    fontSize: 16,
  },
  termSection: {
    lineHeight: '150%',
  },
}));



// WEBPACK FOOTER //
// ./src/components/Privacy/useStyles.js